import { useEffect } from "react";

export const useDebounce = (cb, dep, delay = 200) => {
  useEffect(() => {
    let timer;
    if (cb) {
      timer = setTimeout(cb, delay);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [...dep]);
};
